import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { WalletCard } from '@kr/models';

export interface WalletDetailsApi {
  getWalletDetails(wallet: WalletCard): Observable<WalletCard>;
  editWallet(wallet: WalletCard): Observable<void>;
  deleteWallet(wallet: WalletCard): Observable<void>;
}

export const WALLET_DETAILS_API = new InjectionToken<WalletDetailsApi>('WALLET_DETAILS_API ');
